import { render, staticRenderFns } from "./StampButton.vue?vue&type=template&id=5ce83bc0&scoped=true"
import script from "./StampButton.vue?vue&type=script&lang=ts"
export * from "./StampButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce83bc0",
  null
  
)

export default component.exports